import GoogleSignInButtonRoot, { Props } from './GoogleSignInButton'

export default function GoogleSignInButton(props: Props) {
  return <GoogleSignInButtonRoot {...props} />
}
